<template>
    <EpicorPart></EpicorPart>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const EpicorPart = defineAsyncComponent(() =>
    import("../../components/ProjectManagement/Part/Part.vue")
);

export default {
    name: "Project_EpicorPart",
    components: { EpicorPart, AuthLayout },
};
</script>
